// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"580":"25ae215c","732":"d0a96502"}[chunkId] + ".chunk.css";
};